/**
 * A arte do cartão de trilha.
 *
 * Desenhada aqui, em formas geométricas, e não trazida de fora. Duas razões, e
 * a segunda é a que decide: uma ilustração de terceiros é peso que o orçamento
 * de 200 KB não tem para dar (RNF-001), e copiar a personagem de um concorrente
 * é a única parte da categoria que a skill `design-mimo` proíbe expressamente —
 * copia-se a mecânica, nunca a identidade.
 *
 * As cores vêm todas de classes, nunca de atributos: um `fill` literal num SVG
 * escapa ao verificador de fichas e é exactamente assim que a ficha deixa de
 * ser a fonte da verdade.
 */

/** Motivo por trilha. Quem não tiver o seu cai no genérico, sem partir nada. */
export function ArteDaTrilha({ trilha }: { trilha: string }) {
  return (
    <div className="arte" aria-hidden="true">
      <svg viewBox="0 0 320 120" preserveAspectRatio="xMidYMid slice" focusable="false">
        {trilha === 'javascript' ? <Chavetas /> : null}
        {trilha === 'fullstack' ? <Camadas /> : null}
        {trilha === 'python' ? <Fluxo /> : null}
        {trilha === 'sql' ? <Tabela /> : null}
        {!['javascript', 'fullstack', 'python', 'sql'].includes(trilha) ? <Chavetas /> : null}
      </svg>
    </div>
  );
}

/** JavaScript: chavetas e uma linha de código que se resolve num acento. */
function Chavetas() {
  return (
    <g>
      <path
        className="arte__traco"
        d="M112 28c-14 0-14 26-28 32 14 6 14 32 28 32M208 28c14 0 14 26 28 32-14 6-14 32-28 32"
      />
      <rect className="arte__forma" x="136" y="46" width="48" height="8" rx="4" />
      <rect className="arte__forma arte__forma--fraca" x="136" y="66" width="32" height="8" rx="4" />
      <circle className="arte__acento" cx="188" cy="70" r="7" />
    </g>
  );
}

/** Fullstack: camadas empilhadas — a página, o código, o servidor. */
function Camadas() {
  return (
    <g>
      <rect className="arte__forma arte__forma--fraca" x="104" y="26" width="112" height="22" rx="8" />
      <rect className="arte__forma" x="116" y="52" width="88" height="22" rx="8" />
      <rect className="arte__forma arte__forma--fraca" x="104" y="78" width="112" height="22" rx="8" />
      <circle className="arte__acento" cx="160" cy="63" r="6" />
    </g>
  );
}

/** SQL: linhas e colunas de uma tabela, e a linha que a pergunta apanha. */
function Tabela() {
  return (
    <g>
      <rect className="arte__forma" x="104" y="28" width="112" height="14" rx="5" />
      <rect className="arte__forma arte__forma--fraca" x="104" y="50" width="112" height="14" rx="5" />
      <rect className="arte__forma arte__forma--fraca" x="104" y="72" width="112" height="14" rx="5" />
      <path className="arte__traco" d="M144 24v68M180 24v68" />
      <circle className="arte__acento" cx="198" cy="79" r="6" />
    </g>
  );
}

/** Python: um fluxo que dá a volta e volta ao princípio — o ciclo. */
function Fluxo() {
  return (
    <g>
      <path
        className="arte__traco"
        d="M104 44c0-10 8-18 18-18h32c10 0 18 8 18 18s8 18 18 18h14c10 0 18 8 18 18s-8 18-18 18h-32"
      />
      <circle className="arte__acento" cx="104" cy="44" r="8" />
      <rect className="arte__forma arte__forma--fraca" x="128" y="82" width="40" height="8" rx="4" />
    </g>
  );
}
